import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["aggregate", "taskCopy"]

  connect() {
    this.refresh()
  }

  refresh(event) {
    if (event?.detail?.field && event.detail.field !== "completion_notes") return
    if (!this.hasAggregateTarget) return

    this.updateTaskCopyButton(event)

    const aggregateButton = this.aggregateTarget.querySelector('[data-copy-button-target="button"]')
    if (!aggregateButton) return

    const topLevelCompletedTasks = Array.from(
      this.element.querySelectorAll('#procedure_tasks > .procedure__task.procedure__task--completed')
    )

    const lines = []

    topLevelCompletedTasks.forEach((taskEl) => {
      const parentCopyTarget = taskEl.querySelector(
        '.procedure__task-content > .procedure__task__completed [data-procedure-run-copy-target="taskCopy"]'
      )
      const parentButton = parentCopyTarget?.querySelector('[data-copy-button-base-text-value]')
      const parentText = parentButton?.dataset.copyButtonTextValue || parentButton?.dataset.copyButtonBaseTextValue || ''
      if (parentText.trim().length > 0) lines.push(parentText)

      const subtaskCopyTargets = Array.from(
        taskEl.querySelectorAll(
          '.procedure__subtasks-container .procedure__task.procedure__task--completed [data-procedure-run-copy-target="taskCopy"]'
        )
      )

      subtaskCopyTargets.forEach((copyTarget) => {
        const button = copyTarget.querySelector('[data-copy-button-base-text-value]')
        const text = button?.dataset.copyButtonTextValue || button?.dataset.copyButtonBaseTextValue || ''
        if (text.trim().length > 0) lines.push(`-- ${text}`)
      })
    })

    aggregateButton.dataset.copyButtonTextValue = lines.join("\n")
  }

  updateTaskCopyButton(event) {
    const inlineEditEl = event?.target
    if (!inlineEditEl) return

    const completedContainer = inlineEditEl.closest('.procedure__task__completed')
    if (!completedContainer) return

    const copyTarget = completedContainer.querySelector('[data-procedure-run-copy-target="taskCopy"]')
    const copyButton = copyTarget?.querySelector('[data-copy-button-base-text-value]')
    if (!copyButton) return

    const baseText = copyButton.dataset.copyButtonBaseTextValue || copyButton.dataset.copyButtonTextValue || ''
    const notes = event?.detail?.text || ''
    copyButton.dataset.copyButtonTextValue = notes.trim().length > 0 ?
      `${baseText} - Completion Notes: ${notes}` :
      baseText
  }
}
